import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on all pages
    $('.vertical-center-2').slick({
      dots: true,
      slidesToShow: 5,
      slidesToScroll: 2,
      variableWidth: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
    });

    // $('.header-animation').slick({
    //   dots: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   variableWidth: true,
    //   infinite: false,
    //   autoplay: true,
    //   autoplaySpeed: 10,
    //   draggable: false,
    //   fade: false,
    //   pauseOnHover: false,
    //   swipe: false,
    //   verticalSwiping: false,
    // });

    // $('.header-animation img').each(function (index) {

    var animationIndex = 1;
    let animation = setInterval(function(){
      if (animationIndex !== 29) {
        $('.img' + (animationIndex -1)).removeClass('slide-active');
        $('.img' + animationIndex).addClass('slide-active');
        animationIndex++;
      }
      else {
        clearInterval(animation);
      }

    }, 100);

    // JavaScript to be fired on all pages
    $('.related-news').slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      variableWidth: true,
      infinite: true,
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js